import { useMemo } from 'react'; 
import { useLazyQuery } from '@apollo/client';
import AI_GET_PROMPT from '../queries/AI_GET_PROMPT';
import { getFormattedDate } from '../../utils';

const useAIGetPrompt = () => { 
    const [ fetchPrompt, { data, loading, error } ] = useLazyQuery( AI_GET_PROMPT );

    const prompt = useMemo( () => {
        if ( !data || !data.prompt ) { return; }
    
        return {
            ...data.prompt,
            name: data.prompt.label,
            key: data.prompt.id || '',
            createdAt: getFormattedDate( data.prompt.createdAt ),
            updatedAt: getFormattedDate( data.prompt.updatedAt )
        }; 
    }, [ data ] );
    
    const loadPrompt = ( promptId ) => {
        const vars = {
            variables: {
                id: promptId
            }, 
            fetchPolicy: 'network-only' 
        };

        return fetchPrompt( vars );
    };
   
    return useMemo( () => {
        return {
            loadPrompt,
            promptData: prompt,
            promptError: error,
            promptLoading: loading, 
        };
    }, [ prompt, error, loading ] );
};

export default useAIGetPrompt;
